import { render, staticRenderFns } from "./UninformedPartipants.vue?vue&type=template&id=ee370380&"
import script from "./UninformedPartipants.vue?vue&type=script&lang=js&"
export * from "./UninformedPartipants.vue?vue&type=script&lang=js&"
import style0 from "./UninformedPartipants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports